/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2025-11-07 16:16:42
 */
import mirrorCreator from 'mirror-creator'

export default mirrorCreator([
  'CLEAR',
  'SET_AI_VISUAL_SEARCH_AB',
  'SET_AI_CHAT_DRAWER_VISIBLE',
  'SET_AGENT_CUSTOMER_DRAWER_VISIBLE',
  'SET_PAYMENT_VISIBLE',
  'SET_USER',
  'IS_CHECKING_AUTH',
  'SET_LOADING',
  'SET_INITIAL_REQUEST_FINISHED',
  'SET_OSS_TOKEN',
  'SET_CONFIG',
  'SET_DOWNLOAD_SETTING_MODAL_VISIBLE',
  'SET_HAS_NEW_NOTIFY',

  'SET_PHOTOS_FILTER',
  'SET_QUERY_FILTER',
  'SET_GROUP_INFO',
  'SET_GROUP_CUSTOMER_CONFIG',
  'SET_AI_PHOTO_TAGS_STATE',

  'SET_PHOTOS',
  'SET_PHOTOS_EXPAND_INFO',
  'SET_CAN_FAVORITE',
  'APPEND_PHOTOS',
  'SET_LAST_PAGE_COND',
  'RESET_FILTER',
  'SET_PHOTOS_NUM',
  'SET_CHECK_ALL',
  'PUSH_CHECKED_PHOTO',
  'REMOVE_CHECKED_PHOTO',
  'CLEAR_CHECKED_PHOTO',
  'PUSH_UNCHECKED_PHOTO',
  'REMOVE_UNCHECKED_PHOTO',
  'CLEAR_UNCHECKED_PHOTO',
  'SET_EXPORT_TASKS',
  'CLEAR_PHOTO',
  'SET_EXPORT_LIST_DRAWER_VISIBLE',
  'SET_EXPORT_TASK_TIMER',
  'SET_CLIENT_DOWNLOAD_DRAWER_VISIBLE', // 新增：客户端下载抽屉显示状态
  'SET_CLIENT_DOWNLOAD_TASKS', // 新增：客户端下载任务列表
  'SET_CLIENT_DOWNLOAD_PROGRESS', // 新增：客户端下载进度更新
  'SET_LOCATIONS',
  'SET_WATERMARKS_NUM',
  'SET_SEARCH_TRACKING_ID',
  'SET_IS_ASC_SORT',
  'UPDATE_PHOTO_RECTIFICATION',
  'SET_IS_GROUP_PHOTO_VIEW_LIMIT',

  'CLEAR_GROUP',
  'SET_GROUP_ID',
  'SET_MY_ROLE',
  'SET_GROUP_MEMBERS',
  'SET_GROUP_VIEW_PERM',
  'SET_GROUP_MEMBER_NICKNAME',
  'SET_ONLY_IN_GROUP',

  'SET_PATHWAY_DATE',
  'SET_PATHWAYS',
  'SET_PATHWAY_MEMBERS',
  'SET_PATHWAY_CHECKED_MEMBERS',
  'SET_PATHWAY_CURRENT_USER',
  'SET_PATHWAY_VIEWER_PHOTOS',
  'SET_PATHWAY_USER_LIST_PANEL',
  'CLEAR_PATHWAY',

  'SET_EXPORT_WATERMARK_FILTER',
  'SET_PHOTO_WATERMARK_QUERY_FILTER',
  'RESET_EXPORT_WATERMARK_FILTER',

  'SET_EDITOR_WATERMARK',
  'CLEAR_EDITOR',
  'SET_EDITOR_ACTIVE_ITEM',
  'SET_EXPANDED_PANELS',
  'SET_WATERMARKS',
  'SET_DRAFT_WATERMARKS',
  'SET_EDITOR_GEO_ITEMS_LIST',
  'SET_CASCADE_ITEMS_LIST',

  'SET_ALBUMS',

  'SET_ORGANIZATION',
  'SET_CUR_DEPARTMENT',
  'SET_PARENT_DEPARTMENT_IDS',

  'SET_PICKER_ORGANIZATION',
  'SET_PICKER_ORG_USER_COUNT',

  // 'SET_FOLDERS',
  'SET_FOLDER_DETAIL_LOADING',
  'SET_TOTAL_FOLDERS_COUNT',
  'SET_DEFAULT_FOLDERS_COUNT',
  'SET_FOLDER_PHOTOS',
  'SET_FOLDER_PHOTOS_NUM',
  'SET_CURRENT_VIEW_PHOTO',
  'SET_ALBUM_MENU_VISIBLE',

  'FOLDER_SET_CHECK_ALL',
  'FOLDER_PUSH_CHECKED_PHOTO',
  'FOLDER_REMOVE_CHECKED_PHOTO',
  'FOLDER_CLEAR_CHECKED_PHOTO',
  'FOLDER_PUSH_UNCHECKED_PHOTO',
  'FOLDER_REMOVE_UNCHECKED_PHOTO',
  'FOLDER_CLEAR_UNCHECKED_PHOTO',

  'PHOTO_PICKER_SET_PHOTO',
  'PHOTO_PICKER_APPEND_PHOTO',
  'PHOTO_PICKER_UPDATE_ALL_PHOTOS_STATUS',
  'SET_BACK_FROM_PICKER_PAGE',

  'SET_GROUP_POLICY_LIST',
  'SET_GROUP_AUTH_POLICY',

  // AB
  'SET_PHOTOS_WATERMARKS_TOTAL_PHOTOS',
  'TRIGGER_PHOTO_WATERMARK_EXCEL',
  'SET_EXPORT_DOWNLOAD_PHOTO_ONCE_PARAMS',
  'SET_AB_TEST_CONFIG',
  'SET_AI_VISUAL_SEARCH_AB',
  'SET_OLD_PHOTOS_COUNT',
  'SET_PHOTO_STATISTICS',
  'SET_AI_RECOGNITION_RESULTS'
])
